<template>
    <div>
        <map-location-show :def-location="address"
                      :def-content="placeResultData"></map-location-show>
    </div>
</template>

<script>
    import MapLocationShow from "./MapLocationShow";
    import VueGoogleAutocomplete from 'vue-google-autocomplete';
    import {gmapApi} from 'vue2-google-maps';
    export default {
        name: 'show-map',
        components: {MapLocationShow, VueGoogleAutocomplete},
        computed: {
            google: gmapApi
        },
        data:function () {

            return {
                address: {
                    street_number:22,
                    latitude: 0,
                    longitude: 0
                },
                loading:true,
                placeResultData: ''

            }
        },
        props: {
            lat:{
                required:false,
            },
            lng:{
                required:false,
            },
            formattedAddress:{
                required:false,
            },
            // type:{
            //     required: false,
            // },
            // allObject: {
            //     required:false,
            // }
        },
        methods: {

        },
        mounted() {
            this.loading=true;
            let vm=this;
            vm.address.latitude=parseFloat(vm.lat);
            vm.address.longitude=parseFloat(vm.lng);
            vm.placeResultData=vm.formattedAddress;
            vm.loading=false;

        },
    };
</script>


// WEBPACK FOOTER //
// resources/js/components/ShowMap.vue